import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosedEyeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.48589 7.5522C2.32417 7.30989 2.50751 7 2.79883 7C2.93118 7 3.05348 7.0685 3.12811 7.1778C3.56128 7.81215 4.11037 8.34138 4.77538 8.76549C5.66635 9.33371 6.64453 9.61781 7.70991 9.61781C8.7753 9.61781 9.75422 9.33371 10.6467 8.76549C11.3116 8.34212 11.8582 7.81399 12.2864 7.18112C12.3617 7.06991 12.4856 7 12.6199 7C12.9137 7 13.0986 7.31256 12.9353 7.55683C12.4752 8.24498 11.8948 8.83221 11.194 9.31853C10.1565 10.0386 8.99586 10.3986 7.71214 10.3986C6.42842 10.3986 5.2678 10.0386 4.23027 9.31853C4.17234 9.27832 4.11522 9.23742 4.05893 9.19584C4.04241 9.21903 4.02365 9.24114 4.00263 9.26188L2.87735 10.3721C2.68077 10.5661 2.36207 10.5661 2.1655 10.3721C1.96892 10.1782 1.96892 9.86372 2.1655 9.66978L3.29078 8.55954C3.29493 8.55545 3.29913 8.55144 3.30339 8.54752C2.99814 8.24321 2.72564 7.91144 2.48589 7.5522Z",
			fill: "#2C3F81"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: .5,
			y1: -.5,
			x2: 2.08079,
			y2: -.5,
			transform: "matrix(0.600404 0.799697 -0.791541 0.611116 11 9)",
			stroke: "#2C3F81",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.59083 9.95719L5.45664 11.4752M8.95555 10.0982L9.1273 11.6291",
			stroke: "#2C3F81",
			strokeLinecap: "round"
		})
	]
});
export default SvgClosedEyeIcon;
